export default __webpack_public_path__ + "static/media/right-white-arrow.4e2b8cdb.svg";